import { stringify } from 'query-string';

import { ILinkfireActivityTrendArgs } from 'helpers/interceptors/linkfireActivityTrendInterceptor';

function getLinkfireActivityTrendUrl(args: ILinkfireActivityTrendArgs): string {
  const { entityType, entityIds, period, dateFrom, dateTo } = args;

  const params = stringify({
    period,
    dateFrom,
    dateTo,
  });

  return `/api/marketing/trend/${entityType}/${entityIds}?${params}`;
}

export default getLinkfireActivityTrendUrl;
